import React, {useContext, useEffect, useRef, useState} from "react";
import {useHistory, useParams} from 'react-router-dom';
import * as Yup from "yup";
import {TranslateContext} from "../../context/TranslateContext";
import {
    aggiornaGruppoUtenteApi, aggiungiGruppoUtenteApi, aggiungiPermessoGruppoApi, deleteRelazioneUtenteGruppoApi,
    getGruppiUtenteByIdApi,
    getPermessiGruppoApi,
    getUtentiAssociatiAGruppoApi
} from "./services/GruppiUtentiServices";
import ModificaGruppoUtenteView from "./ModificaGruppoUtenteView";
import UtentiAssociatiController from "./components/UtentiAssociatiController";
import PermessiKpiController from "./components/PermessiKpiController";
import FormModificaGruppoUtente from "./components/FormModificaGruppoUtente";
import {getListaKpiApi} from "../kpi/services/KpiServices";

export default function ModificaGruppoUtenteController() {
    const {id} = useParams()

    const [keyTab, setKeyTab] = useState(0);

    const [idGruppo, setIdGruppo] = useState(id);
    const [show, setShow] = useState(false);
    const [showModalDelAssociato, setShowModalDelAssociato] = useState(false);
    const [showModalAddAssociati, setShowModalAddAssociati] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);
    const [permessiKpi, setPermessiKpi] = useState([]);
    const [utentiAssociati, setUtentiAssociati] = useState([]);
    const [relAssociatoSel, setRelAssociatoSel] = useState([]);

    const {translate, lingua, loadingNewLang} = useContext(TranslateContext);

    const formikRef = useRef();
    const history = useHistory();

    async function getGruppo() {
        const response = await getGruppiUtenteByIdApi(idGruppo);
        if (formikRef.current) {
            formikRef.current.setFieldValue("id_gruppo_utente", response.data.data.id_gruppo_utente);
            formikRef.current.setFieldValue("codice", response.data.data.codice || '');
            formikRef.current.setFieldValue("descrizione", response.data.data.descrizione || '');
            formikRef.current.setFieldValue("note", response.data.data.note || '');
            formikRef.current.setFieldValue("canc", response.data.data.canc);
        }
    }

    async function getUtentiAssociati() {
        const response = await getUtentiAssociatiAGruppoApi(idGruppo);
        setUtentiAssociati(response.data.data);
    }

    async function getKpi() {
        let permessiDb = await getPermessiGruppoApi(idGruppo);

        const response = await getListaKpiApi('?addTipi=1');
        let kpi = response.data.data;
        if (kpi) {
            let permessiKpiNew = [];
            kpi.forEach((k) => {
                let permCorrente = {
                    id_kpi: k.id_kpi,
                    tipo_imp_dati: k.tipo_imp_dati,
                    id_tipo_imp_dati: k.id_tipo_imp_dati,
                    kpi_macrocategoria: k.kpi_macrocategoria,
                    codice: k.codice,
                    descrizione: k.descrizione,
                    lettura: 0,
                    scrittura: 0,
                    approvazione: 0,
                    revisione: 0,
                    configurazione: 0,
                };

                // Se la configurazione è già stata salvata su db, recupero i permessi salvati
                if (permessiDb && permessiDb.data.data) {
                    let permCorrenteDb = permessiDb.data.data.filter((p) => p.id_kpi == k.id_kpi && p.id_tipo_imp_dati == k.id_tipo_imp_dati)
                    if (permCorrenteDb && permCorrenteDb.length > 0) {
                        permCorrente.lettura = permCorrenteDb[0].lettura;
                        permCorrente.scrittura = permCorrenteDb[0].scrittura;
                        permCorrente.approvazione = permCorrenteDb[0].approvazione;
                        permCorrente.revisione = permCorrenteDb[0].revisione;
                        permCorrente.configurazione = permCorrenteDb[0].configurazione;
                    }
                }

                permessiKpiNew.push(permCorrente);
            });

            setPermessiKpi(permessiKpiNew);
        }
    }

    useEffect(() => {
        if (idGruppo && idGruppo !== '' && loadingNewLang === false) {
            getGruppo();
            getKpi();
            getUtentiAssociati();
        }
    }, [lingua, loadingNewLang, idGruppo]);

    useEffect(() => {
        if (keyTab === 0) {
            getGruppo();
        }
    }, [keyTab]);

    const SignupSchema = Yup.object().shape({
        codice: Yup.string()
            .max(20, translate('Valore troppo lungo'))
            .required(translate('Questo campo è obbligatorio')),
        descrizione: Yup.string()
            .max(200, translate('Valore troppo lungo'))
            .required(translate('Questo campo è obbligatorio')),
        note: Yup.string()
            .max(500, translate('Valore troppo lungo'))
            .nullable(),
    });

    async function aggiornaGruppoUtente(values) {
        const response = await aggiornaGruppoUtenteApi(idGruppo, values);
        if (response.data.result === 0) {
            // history.goBack();
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    async function aggiungiGruppoUtente(values) {
        const response = await aggiungiGruppoUtenteApi(values);
        if (response.data.result === 0) {
            setIdGruppo(response.data.data.id_gruppo_utente);
            // history.goBack();
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    const initialFormValuesGruppiUtente = {
        id_gruppo_utente: '',
        codice: '',
        descrizione: '',
        note: '',
        canc: ''
    };

    function onSubmitFormGruppiUtente(values) {
        if (idGruppo) {
            aggiornaGruppoUtente(values);
        } else {
            aggiungiGruppoUtente(values);
        }
    }

    const scrollableTabs = [
        {
            title: idGruppo ? translate("Modifica Gruppo Utente") : translate("Inserisci Gruppo Utente"),
            content: <FormModificaGruppoUtente
                formikRef={formikRef}
                idGruppo={idGruppo}
                SignupSchema={SignupSchema}
                initialFormValuesGruppiUtente={initialFormValuesGruppiUtente}
                onSubmitFormGruppiUtente={onSubmitFormGruppiUtente}
            />
        },
        {
            title: translate("Permessi KPI"),
            content: <PermessiKpiController
                translate={translate}
                permessiKpi={permessiKpi}
                setPermessiKpi={setPermessiKpi}
            />
        },
        idGruppo && idGruppo !== '' && {
            title: translate("Utenti associati"),
            content: <UtentiAssociatiController
                setShowModalDelAssociato={setShowModalDelAssociato}
                translate={translate}
                utentiAssociati={utentiAssociati}
                setRelAssociatoSel={setRelAssociatoSel}
            />
        }
    ];

    async function deleteRelazioneUtenteGruppo() {
        const response = await deleteRelazioneUtenteGruppoApi(idGruppo, relAssociatoSel.id_rel_gruppo_utente);
        if (response.data.result === -1) {
            setModalMsg(response.data.description)
            setShow(true)
        } else {
            setUtentiAssociati(response.data.data);
        }
    }

    async function aggiungiPermessoGruppo() {
        const response = await aggiungiPermessoGruppoApi(idGruppo, permessiKpi);
        if (response.data.result !== 0) {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    function handleOkEliminaAssosc() {
        setShowModalDelAssociato(false);
        deleteRelazioneUtenteGruppo();
    }

    function handleOkAddAssosc() {
        setShowModalAddAssociati(false)
        getUtentiAssociati();
    }

    const bottoniSx = [
        {
            icon: 'fas fa-angle-left',
            command: () => {
                history.goBack();
            }
        }
    ];

    const bottoniDx = [
        keyTab === 0 && {
            label: translate("Salva"),
            icon: "fas fa-save",
            command: () => {
                if (formikRef.current) {
                    formikRef.current.handleSubmit()
                }
            }
        },
        keyTab === 1 && {
            label: translate("Salva"),
            icon: "fas fa-save",
            command: aggiungiPermessoGruppo
        },
        keyTab === 2 && {
            label: translate("Aggiungi utenti"),
            icon: "fas fa-plus-circle",
            command: () => {
                setShowModalAddAssociati(true);
            }
        }
    ];

    return (
        <ModificaGruppoUtenteView
            formikRef={formikRef}
            keyTab={keyTab}
            modalMsg={modalMsg}
            show={show}
            setShow={setShow}
            showModalDelAssociato={showModalDelAssociato}
            setShowModalDelAssociato={setShowModalDelAssociato}
            idGruppo={idGruppo}
            relAssociatoSel={relAssociatoSel}
            scrollableTabs={scrollableTabs}
            setKey={setKeyTab}
            setShowModalAddAssociati={setShowModalAddAssociati}
            showModalAddAssociati={showModalAddAssociati}
            handleOkEliminaAssosc={handleOkEliminaAssosc}
            handleOkAddAssosc={handleOkAddAssosc}
            bottoniSx={bottoniSx}
            bottoniDx={bottoniDx}
        />
    );
}